export const environment = {
    production: true,
    apiEndPoint: 'https://pna-api.akino.vn/'
};
